import { UrlFetcher } from '@flowus/common/hooks/url-fetcher';
import { request } from 'src/common/request';
import { judgeSharePage } from './getPageId';

export const urlFetcher = new UrlFetcher({
  request,
  getIsShare: judgeSharePage,
});
